/* globals _ */

import SelectableSet from './selectable-set';
import Checkbox from '../views/checkbox';

import Collection from '../collections/base';

const { extend } = _;

export default SelectableSet.extend( {
	modelView: Checkbox,

	events: {
		'click .-all': 'checkAll',
		'click .-none': 'checkNone',
	},

	listeners: extend( {}, SelectableSet.prototype.listeners, {
		'collection reset update': 'updateChecked',
		'checked reset update': 'applyChecked',
	} ),

	initialize: function( options = {} ) {
		this.checked = options.checked || new Collection();
		this.defaultChecked = options.defaultChecked || false;

		SelectableSet.prototype.initialize.apply( this, arguments );

		this.childOptions.checked = this.defaultChecked;

		this.on( 'child:select child:unselect', this.updateCheckedItem );
		this.on( 'child:select child:unselect', this.reportChecked );
		this.on( 'child:select child:unselect', this.renderStatus );

		this.on( 'rebind', this.updateChecked );
		this.on( 'rebind', this.applyChecked );

		this.updateChecked();
	},

	getValue: function() {
		return this.checked.pluck( 'id' );
	},

	reportChecked: function() {
		this.trigger( 'change', this.getValue() );
	},

	updateChecked: function() {
		this.checked.set( this.collection.models, { add: this.defaultChecked, merge: false, reset: true } );
	},

	applyChecked: function() {
		this.each( child => child.change( this.checked.contains( child.model ) ) );
	},

	updateCheckedItem: function( child ) {
		// Add or remove from the list
		if ( child.isChecked ) {
			this.checked.add( child.model );
		} else {
			this.checked.remove( child.model );
		}
	},

	reset: function( values ) {
		if ( ! ( values instanceof Array ) ) {
			values = [ values ];
		}

		this.checked.set( this.collection.get( values ) );

		return this;
	},

	checkAll: function() {
		this.each( child => child.check() );
	},

	checkNone: function() {
		this.each( child => child.uncheck() );
	},
} );
